import { z } from 'zod';
import type {
  AssignedOrganization,
  OidcUserProfile,
  UserinfoIdentity,
} from './userinfo';

export const assignedOrganizationSchema = z.object({
  name: z.string(),
  type: z.enum(['organization', 'marketparticipant', 'subunit']),
  id: z.string(),
  externalId: z.string(),
  marketRole: z.string().optional(),
  status: z.string().optional(),
  ean13: z.string().optional(),
  registrationNumber: z.string().optional(),
  registrationNumberOrigin: z.string().optional(),
}) satisfies z.ZodType<AssignedOrganization>;

export const assignedOrganizationWithRolesSchema =
  assignedOrganizationSchema.extend({
    roles: z.array(z.string()),
  }) satisfies z.ZodType<AssignedOrganization<true>>;

export const userinfoIdentitySchema = z.object({
  current: z.string(),
  external: z.object({
    car: z.string().optional(),
  }),
  assigned: z.record(z.string(), assignedOrganizationSchema),
}) satisfies z.ZodType<UserinfoIdentity>;

export const userinfoIdentityWithAssignedRolesSchema =
  userinfoIdentitySchema.extend({
    assigned: z.record(z.string(), assignedOrganizationWithRolesSchema),
  }) satisfies z.ZodType<UserinfoIdentity<true>>;

const oidcUserProfileFields = {
  sub: z.string(),
  roles: z.array(z.string()).default([]),
  authz_roles: z.array(z.string()).default([]),
  email: z.string(),
  given_name: z.string(),
  family_name: z.string(),
  name: z.string(),
};

export const oidcUserProfileSchema = z.object({
  ...oidcUserProfileFields,
  identity: userinfoIdentitySchema,
}) satisfies z.ZodType<OidcUserProfile>;

export const oidcUserProfileWithAssignedRolesSchema =
  oidcUserProfileSchema.extend({
    identity: userinfoIdentityWithAssignedRolesSchema,
  }) satisfies z.ZodType<OidcUserProfile<true>>;
